// extracted by mini-css-extract-plugin
export default {"authorization":"Consent_authorization__oTz81","terms":"Consent_terms__BGkFN","loginButton":"Consent_loginButton__I3idf"};